"use client"

import Image from "next/image"
import PropTypes from "prop-types"

import { useLocaleConfig } from "@/providers/localeConfig"
import theme from "@/theme"
import { removeUnits } from "@/utils/strings"

import { LogoLink, MainNavigation, Nav, ScrollableItems } from "./styled"

const getLogoSizes = (logo) => ({
  big: { width: removeUnits(logo.big.width), height: removeUnits(logo.big.height) },
  small: { width: removeUnits(logo.small.width), height: removeUnits(logo.small.height) },
})

export const AuthNavigation = ({ className }) => {
  const logoSize = getLogoSizes(theme.widgets.navigation.sizes.logo)
  const locale = useLocaleConfig().locale ?? "de-DE"

  return (
    <Nav className={className}>
      <MainNavigation>
        <LogoLink href={`/${locale}`}>
          <Image
            src="/images/logo.svg"
            alt="einzA logo image"
            width={logoSize.small.width}
            height={logoSize.small.height}
            quality={100}
          />
        </LogoLink>
        {/* `ScrollableItems` is only needed for styling here */}
        <ScrollableItems />
      </MainNavigation>
    </Nav>
  )
}

AuthNavigation.propTypes = {
  /** Defines css classes for styling */
  className: PropTypes.string,
}
